export class ListCloudSnapshotsResponse {
    'snapshotsPerVolume';
    'restorePoints';
    'recoveryPoints';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotsPerVolume",
            "baseName": "snapshotsPerVolume",
            "type": "Array<CloudSnapshotsPerVolume>",
            "format": ""
        },
        {
            "name": "restorePoints",
            "baseName": "restorePoints",
            "type": "Array<AzureRestorePointData>",
            "format": ""
        },
        {
            "name": "recoveryPoints",
            "baseName": "recoveryPoints",
            "type": "Array<RecoveryPointData>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCloudSnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
